import { render, staticRenderFns } from "./input-color.vue?vue&type=template&id=e571c718&"
import script from "./input-color.vue?vue&type=script&lang=js&"
export * from "./input-color.vue?vue&type=script&lang=js&"
import style0 from "./input-color.vue?vue&type=style&index=0&id=e571c718&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports